import React from "react";
import { Helmet } from "react-helmet";

const Seo = ({
  title = "Burj Al Yarmouk Industries LLC – Engineering, Fabrication & Metal Works UAE",
  description = "We specialize in engineering, fabrication, storage tanks, fuel tanks, generator enclosures, STP tanks, skid frames, pipeline structures, and custom metal fabrication services in the UAE.",
  url = "https://burjalyarmouk.com/",
  image = "https://burjalyarmouk.com/og-banner.jpg",
  keywords = "fabrication UAE, engineering company UAE, metal fabrication Abu Dhabi, generator enclosure, skid frames, storage tank fabrication, STP tank UAE",
  schema = null,
  twitterHandle = "@burjalyarmouk",
}) => {
  /** DEFAULT STRUCTURED DATA (Organization) **/
  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Burj Al Yarmouk Industries LLC",
    url,
    logo: "https://burjalyarmouk.com/favicon.ico",
    image,
    description,
    address: {
      "@type": "PostalAddress",
      addressLocality: "Abu Dhabi",
      addressRegion: "Abu Dhabi",
      addressCountry: "AE",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+971508517296",
      contactType: "customer service",
    },
    sameAs: [
      "https://www.linkedin.com/in/burj-al-yarmouk-industries-llc-417570347",
      "https://www.instagram.com/burjalyarmouk",
    ],
  };

  return (
    <Helmet>
      {/* Primary Meta */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Burj Al Yarmouk Industries L.L.C" />
      <meta name="robots" content="index, follow" />

      {/* Canonical */}
      {url && <link rel="canonical" href={url} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta
        property="og:site_name"
        content="Burj Al Yarmouk Industries L.L.C"
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      {twitterHandle && <meta name="twitter:site" content={twitterHandle} />}
      {twitterHandle && <meta name="twitter:creator" content={twitterHandle} />}

      {/* JSON-LD Schema */}
      <script type="application/ld+json">
        {JSON.stringify(schema || defaultSchema)}
      </script>
    </Helmet>
  );
};

export default Seo;
